import { styled } from '@stitches/react'

export const StyledSearchResult = styled('div', {
    ul: {
        listStyle: 'none',
    },
})
